import { render, staticRenderFns } from "./comp_ProductCard.vue?vue&type=template&id=35d7fe75&scoped=true"
import script from "./comp_ProductCard.vue?vue&type=script&lang=js"
export * from "./comp_ProductCard.vue?vue&type=script&lang=js"
import style0 from "./comp_ProductCard.vue?vue&type=style&index=0&id=35d7fe75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d7fe75",
  null
  
)

export default component.exports